import { ExpandableBlock } from "@circle-react-uikit/ExpandableBlock";
import { useItemData } from "./ItemDataProvider";

export interface PanelProps {
  children?: React.ReactNode;
  className?: string;
  panelClassName?: string;
}

export const Panel = ({ className, panelClassName, children }: PanelProps) => {
  const { renderPanel, onCloseItemAndOpenNext } = useItemData();

  return (
    <ExpandableBlock.Panel className={panelClassName}>
      {renderPanel ? (
        renderPanel({ onCloseItemAndOpenNext })
      ) : (
        <div className={className}>{children}</div>
      )}
    </ExpandableBlock.Panel>
  );
};
